import { Component, OnInit, output, input, model, inject } from '@angular/core';

import { ApContentService, ApContentPipe } from '@ap/content';
import { ApIconComponent } from '@ap/icon';

import content from './expand.content.json';

@Component({
    selector: 'ap-expand-button',
    templateUrl: './expand.component.html',
    styleUrls: ['./expand.component.scss'],
    imports: [ApIconComponent, ApContentPipe]
})
export class ApExpandButtonComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Establishes relationship between the current element and the expanding element. Its value should be an element ID,
     * that refers to the expanding element.
     */
    public readonly ariaControls = input<string>();
    /**
     * Used to define a string that labels the current element.
     * Use it in cases where a text label is not visible on the screen
     */
    public readonly ariaLabel = input<string>();

    /**
     * Establishes relationships between objects and their label(s), and its value should be one or more element IDs,
     * which refer to elements that have the text needed for labeling
     */
    public readonly ariaLabelledBy = input<string>();

    /**
     * Label for opened state
     */
    public readonly openLabel = input<string>();

    /**
     * Label for closed state
     */
    public readonly closeLabel = input<string>();

    /**
     * Is the button expanded by default?
     */
    public readonly expanded = model(false);

    /**
     * Everytime the button is clicked it emits the expanded state
     */
    public readonly toggled = output<boolean>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    protected buttonClicked(): void {
        this.expanded.set(!this.expanded());
        this.toggled.emit(this.expanded());
    }
}
